import { FC } from "react";
import { t } from "i18next";

// Helpers
import { roundNumber } from "@/_helpers/number_functions";

// Services and Interfaces
import { Macro } from "@/interfaces/nutrition/nutrition_builder";

// Components
import { Box, LinearProgress, Skeleton } from "@mui/material";


interface _MacroIndicatorProps {
    macro: Macro;
    value: number;
    calories: number;
    servings?: number;
    isLoading?: boolean;
}

const MacroIndicator: FC<_MacroIndicatorProps> = ({
    macro,
    value,
    calories,
    servings = 1,
    isLoading
}) => {

    const caloriesPerGram = macro == 'fat' ? 9 : 4;
    const percentageOfCalories = roundNumber(((value * caloriesPerGram) / calories) * 100, 0);
    const servingValue = value / servings;

    return (
        <Box display="flex" flexDirection="column" rowGap="8px" width="100%" maxWidth="290px" justifyContent="center">
            
            {isLoading ? 
                <Skeleton variant="rectangular" width="100%" height={18} /> :
                <Box display="flex" width="100%">
                    <span className="label-text-01">{t(`components.nutritionBuilder.macros.${macro}`)}</span>
                    <Box display="flex" flexGrow={1} />
                    <span className="label-text-01" style={{color: 'var(--text-placeholder)', marginRight: '10px'}}>{percentageOfCalories}%</span>
                    <span className="label-text-01">{roundNumber(servingValue, 1)}g</span>
                </Box>}

            <LinearProgress
                color="primary"
                variant="determinate"
                value={percentageOfCalories}
                sx={{
                    width: '100%', 
                    height: '4px',
                    bgcolor: 'var(--border-subtle-01)',
                    borderRadius: '6px',
                    '& .MuiLinearProgress-bar': {
                        bgcolor: `var(--${macro})`
                    }
                }}
                />
        </Box>
    )
}

export default MacroIndicator;